import { backendApi, Result } from "./backendApi";
import { MakeModel } from "./makeAPI";
import { DataFileModel } from "./vehicleFileAPI";

export interface YearlyOverviewVehicleFileViewModel {
  number: string;
  make: MakeModel;
  checkedOutBy: string | undefined;
  currentYear: number;
  endYearsForVehicles: number[];
  dataFiles: DataFileModel[];
  allModelInfosValidated: boolean;
  hasModelInfo: boolean;
}

export interface YearlyOverviewVehicleFileDetailsViewModel {
  number: string;
  description: string | null;
  make: MakeModel;
  checkedOutBy: string;
  vehicles: ModelInfoReviewViewModel[];
  remainingVehiclesForReview: number;
}

export interface ModelInfoYearEndModel {
  recId: number;
  yearEnd: number;
  version: number;
}

export interface ModelInfoReviewViewModel extends ModelInfoYearEndModel {
  [key: string]: number | string | string[] | number[] | undefined;
  region: string;
  model: string;
  modelTypes: string[];
  modelVariants: string[];
  modelInfo: string;
  extraModelInfo: string;
  fuelType: string;
  hybridTypeId: number | undefined;
  cylinderCount: number;
  engineSize: number;
  engineCodes: string[];
  drivetrainMaximumKws: number[];
  drivetrainNominalKws: number[];
  engineMaximumKws: number[];
  engineNominalKws: number[];
  engineFrontAxle1MaximumKws: number[];
  engineFrontAxle1NominalKws: number[];
  engineFrontAxle2MaximumKws: number[];
  engineFrontAxle2NominalKws: number[];
  engineRearAxle1MaximumKws: number[];
  engineRearAxle1NominalKws: number[];
  engineRearAxle2MaximumKws: number[];
  engineRearAxle2NominalKws: number[];
  mildHybridMaximumKws: number[];
  mildHybridNominalKws: number[];
  electric1MaximumKws: number[];
  electric1NominalKws: number[];
  electric2MaximumKws: number[];
  electric2NominalKws: number[];
  electric3MaximumKws: number[];
  electric3NominalKws: number[];
  electric4MaximumKws: number[];
  electric4NominalKws: number[];
  monthEnd: number;
}

class GetYearlyOverviewVehicleFilesRequest {}

class GetYearlyOverviewVehicleFilesResponse {
  yearlyOverviewVehicleFiles?: YearlyOverviewVehicleFileViewModel[];
}

class GetYearlyOverviewVehicleFileDetailsRequest {
  makeCode?: string;
}

class UpdateModelInfoYearEndRequest {
  vehicleFileNumber?: string;
  modelInfos?: ModelInfoYearEndModel[];
}

class GetYearlyOverviewVehicleFileDetailsResponse {
  yearlyOverviewVehicleFileDetails?: YearlyOverviewVehicleFileDetailsViewModel;
}

export const yearlyReviewApi = {
  async getYearlyOverviewVehicleFiles(): Promise<
    Result<YearlyOverviewVehicleFileViewModel[]>
  > {
    let response =
      await backendApi.sendAndGetResponseAsync<GetYearlyOverviewVehicleFilesResponse>(
        "GetYearlyOverviewVehicleFiles",
        {} as GetYearlyOverviewVehicleFilesRequest,
      );

    if (response.ok) {
      return {
        ok: true,
        value: response.value.yearlyOverviewVehicleFiles ?? [],
      };
    }

    return response;
  },

  async getYearlyOverviewVehicleFileDetails(
    makeCode: string,
    yearEnd: number,
  ): Promise<Result<YearlyOverviewVehicleFileDetailsViewModel>> {
    let response =
      await backendApi.sendAndGetResponseAsync<GetYearlyOverviewVehicleFileDetailsResponse>(
        "GetYearlyOverviewVehicleFileDetails",
        {
          makeCode: makeCode,
          yearEnd: yearEnd,
        } as GetYearlyOverviewVehicleFileDetailsRequest,
      );

    if (response.ok) {
      return {
        ok: true,
        value: response.value.yearlyOverviewVehicleFileDetails!,
      };
    }

    return response;
  },

  async updateModelInfoYearEnd(
    vehicleFileNumber: string,
    modelInfos: ModelInfoYearEndModel[],
  ): Promise<Result<any>> {
    let response = await backendApi.sendAsync("UpdateModelInfoYearEnd", {
      vehicleFileNumber: vehicleFileNumber,
      modelInfos: modelInfos,
    } as UpdateModelInfoYearEndRequest);

    return response;
  },
};
